import { fg } from '@atlassian/jira-feature-gating';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getServiceDeskNavigationResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { helpCenterSettingsSupportWebsiteOverviewRoute } from '@atlassian/jira-router-routes-help-center-settings-routes/src/helpCenterSettingsSupportWebsiteOverviewRoute.tsx';

import AsyncHelpCenterSettingsSidebar from '@atlassian/jira-navigation-apps-sidebar-help-center-settings/src/async.tsx';

import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { AsyncSupportWebsiteNav } from '@atlassian/jira-horizontal-nav-csm-support-website/src/index.tsx';
import {
	HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint,
	HelpCenterSettingsSupportWebsiteOverviewAppEntryPointWithHorizontalNavigation,
} from './ui/support-website-overview/index.tsx';

export const helpCenterSettingsSupportWebsiteOverviewRouteEntry = createEntry(
	helpCenterSettingsSupportWebsiteOverviewRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'customer-service.support-website.overview',
		layout: serviceProjectLayout,
		navigation: {
			sidebarId: SIDEBAR_ID.HELP_CENTER_SETTINGS,
			menuId: MENU_ID.HELP_CENTER_SETTINGS,
			sidebar: AsyncHelpCenterSettingsSidebar,
			horizontal: fg('csm_contact_us_rte') ? undefined : AsyncSupportWebsiteNav,
		},
		component: ErrorPagesNotFound,
		entryPoint: () => {
			if (!fg('enable_support_site_details_csm')) {
				return undefined;
			}
			return fg('csm_contact_us_rte')
				? HelpCenterSettingsSupportWebsiteOverviewAppEntryPointWithHorizontalNavigation
				: HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint;
		},
		resources: [...getServiceDeskNavigationResources()],
	}),
);
